import React, { useReducer } from "react";

import UserContext from "./userContext";
import { userReducer } from "./userReducer";

export const SET_CURRENCY = "SET_CURRENCY";
export const SET_LANGUAGE = "SET_LANGUAGE";

const UserState = ({ children }) => {
  const initialState = {
    currency: "USD",
    language: "English",
    phone: "(12345)67890",
    email: "mhhasanul@gmail.com",
    fullName: "IyanuOluwa Sowande",
  };

  const [state, dispatch] = useReducer(userReducer, initialState);

  const setCurrency = value => dispatch({ type: SET_CURRENCY, payload: value });
  const setLanguage = value => dispatch({ type: SET_LANGUAGE, payload: value });

  return (
    <UserContext.Provider
      value={{
        user: state,

        setCurrency,
        setLanguage,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export default UserState;
